import styles from './SubscribeButton.module.css';
const SubscribeButton = ({
  onClick,
  isLocked,
}: {
  onClick: () => void;
  isLocked: boolean;
}) => {
  return (
    <button
      className={styles.subscribeButton}
      onClick={onClick}
      disabled={isLocked}
    >
      Открыть ссылку
    </button>
  );
};

export default SubscribeButton;
